(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halo-article-content"]) return;
  try {
    
  class HaloArticleContent extends HTMLElement {
    connectedCallback() {
      const body = this.querySelector('[data-hb-article-body]');
      const toc = this.querySelector('[data-hb-article-toc]');
      const list = this.querySelector('[data-hb-article-toc-list]');
      const progress = this.querySelector('[data-hb-article-progress]');
      if (!body || !toc || !list) return;
      list.replaceChildren();
      toc.hidden = true;
      const headings = [...body.querySelectorAll('h2, h3')];
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `${this.dataset.sectionId}-article-section-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        if (heading.tagName === 'H3') link.style.paddingInlineStart = '12px';
        item.append(link);
        list.append(item);
      });
      toc.hidden = !headings.length;
      this.updateProgress = () => {
        if (!progress) return;
        const rect = body.getBoundingClientRect();
        const total = Math.max(body.offsetHeight - window.innerHeight * .5, 1);
        const complete = Math.min(1, Math.max(0, -rect.top / total));
        progress.style.width = `${complete * 100}%`;
      };
      window.addEventListener('scroll', this.updateProgress, { passive: true });
      this.updateProgress();
    }
    disconnectedCallback() {
      if (this.updateProgress) window.removeEventListener('scroll', this.updateProgress);
    }
  }
  if (!customElements.get('halo-article-content')) customElements.define('halo-article-content', HaloArticleContent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halo-before-after-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halo-image-reveal')) {
    customElements.define('halo-image-reveal', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.cards = [...this.querySelectorAll('[data-hir-card]')];
        this.hint = this.querySelector('[data-hir-hint]');
        this.cards.forEach(card => {
          const input = card.querySelector('[data-hir-range]');
          if (!input) return;
          this.setSplit(card, input.defaultValue);
          card.dataset.enhanced = '';
          input.hidden = false;
        });
        if (this.hint) this.hint.hidden = !this.cards.some(card => card.querySelector('[data-hir-range]'));
        this.addEventListener('input', event => {
          const input = event.target.closest('[data-hir-range]');
          if (input) this.setSplit(input.closest('[data-hir-card]'), input.value);
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
          if (card) card.scrollIntoView({ behavior: 'auto', block: 'nearest' });
        }, { signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.cards?.forEach(card => {
          delete card.dataset.enhanced;
          card.style.removeProperty('--hir-split');
          const input = card.querySelector('[data-hir-range]');
          if (input) input.hidden = true;
        });
        if (this.hint) this.hint.hidden = true;
      }

      setSplit(card, value) {
        const input = card?.querySelector('[data-hir-range]');
        if (!input) return;
        const number = Number(value);
        const split = Math.max(0, Math.min(100, Math.round(Number.isFinite(number) ? number : 50)));
        input.value = String(split);
        card.style.setProperty('--hir-split', `${split}%`);
        input.setAttribute('aria-valuetext', input.dataset.hirValueTemplate.replaceAll('__HIR_BEFORE__', String(split)).replaceAll('__HIR_AFTER__', String(100 - split)));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halo-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halo-before-after')) {
    customElements.define('halo-before-after', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.cards = [...this.querySelectorAll('[data-hba-card]')];
        this.reset();
        this.dataset.enhanced = '';
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-hba-state]');
          if (button && !button.disabled) this.setState(button.closest('[data-hba-card]'), button.dataset.hbaState);
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
          if (card) card.scrollIntoView({ behavior: 'auto', block: 'nearest' });
        }, { signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
        delete this.dataset.enhanced;
        this.cards?.forEach(card => {
          delete card.dataset.state;
          card.querySelectorAll('[data-hba-image]').forEach(image => image.removeAttribute('aria-hidden'));
          card.querySelector('[data-hba-controls]').hidden = true;
        });
      }

      reset() {
        this.cards.forEach(card => this.setState(card, this.dataset.initialState === 'after' ? 'after' : 'before'));
      }

      setState(card, state) {
        if (!card || !['before', 'after'].includes(state)) return;
        const buttons = [...card.querySelectorAll('[data-hba-state]')];
        const available = buttons.filter(button => !button.disabled);
        if (!available.some(button => button.dataset.hbaState === state) && available.length) state = available[0].dataset.hbaState;
        card.dataset.state = state;
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hbaState === state)));
        card.querySelectorAll('[data-hba-image]').forEach(image => image.setAttribute('aria-hidden', String(image.dataset.hbaImage !== state)));
        card.querySelector('[data-hba-controls]').hidden = available.length < 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halo-media-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halo-media-slider')) {
    customElements.define('halo-media-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.querySelectorAll('[data-media-clone]').forEach(slide => slide.remove());
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        if (!this.track || !this.slides.length) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.videos = [...this.querySelectorAll('video')];
        this.rotation = this.querySelector('[data-rotation]');
        this.status = this.querySelector('[data-status]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = Math.min(this.activeIndex ?? (Number(this.dataset.startIndex) || 0), this.slides.length - 1);
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || this.dataset.designMode === 'true';
        this.hovered = false;
        this.dragging = false;
        this.inView = false;
        this.loop = null;
        this.playRequest = (this.playRequest || 0) + 1;
        this.videoRequests ||= new WeakMap();
        this.dataset.enhanced = '';
        this.slides.forEach((slide, index) => { slide.dataset.mediaIndex = index; });
        this.videos.forEach(video => this.setPlayback(video));
        this.addEventListener('click', event => {
          const play = event.target.closest('[data-play]');
          if (play) { this.pause(); this.playVideo(play.closest('[data-slide]')); }
          if (event.target.closest('[data-rotation]')) {
            this.paused = !this.paused;
            this.scheduleRotation();
          }
          if (event.target.closest('[data-previous], [data-next]')) {
            this.pause();
            this.stopMedia();
            this.step(event.target.closest('[data-next]') ? 1 : -1);
          }
        }, { signal });
        this.addEventListener('focusin', event => { if (event.target !== this.rotation) this.pause(); }, { signal });
        this.track.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.scheduleRotation(); }
        }, { signal });
        this.track.addEventListener('pointerleave', () => { this.hovered = false; this.scheduleRotation(); }, { signal });
        this.track.addEventListener('pointerdown', () => { this.dragging = true; this.scheduleRotation(); }, { signal });
        for (const type of ['pointerup', 'pointercancel']) document.addEventListener(type, () => {
          if (!this.dragging) return;
          this.dragging = false;
          this.scheduleRotation();
        }, { signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          event.preventDefault();
          this.pause();
          this.stopMedia();
          if (event.key === 'Home' || event.key === 'End') this.goTo(event.key === 'Home' ? 0 : this.slides.length - 1);
          else this.step(event.key === 'ArrowRight' ? direction : -direction);
        }, { signal });
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.timer);
          clearTimeout(this.settleTimer);
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = 0;
            const bounds = this.track.getBoundingClientRect();
            const centre = bounds.left + this.track.clientWidth / 2;
            let nearest = 0;
            let distance = Infinity;
            this.items.forEach((slide, index) => {
              const card = slide.getBoundingClientRect();
              const nextDistance = Math.abs(card.left + card.width / 2 - centre);
              if (nextDistance < distance) { nearest = index; distance = nextDistance; }
            });
            this.select(nearest);
          });
          this.settleTimer = setTimeout(() => this.finishScroll(), 120);
        }, { signal, passive: true });
        for (const type of ['play', 'pause', 'ended', 'error']) {
          this.addEventListener(type, event => {
            const video = event.target;
            if (!this.videos.includes(video)) return;
            if (type === 'play') {
              if (!this.canPlay(video)) { this.pauseVideo(video); return; }
              this.goTo(this.slides.indexOf(video.closest('[data-slide]')), true);
              this.videos.forEach(other => { if (other !== video) this.pauseVideo(other); });
              if (this.pendingVideo !== video) this.videoRequests.set(video, ++this.playRequest);
            } else if (this.pendingVideo === video) {
              this.playRequest++;
              this.pendingVideo = null;
            }
            this.setPlayback(video);
            if (type === 'error') this.status.textContent = this.dataset.playError;
            this.scheduleRotation();
          }, { signal, capture: true });
        }
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.pause(); this.stopMedia(); this.goTo(index, true); }
        }, { signal });
        document.addEventListener('shopify:section:reorder', event => { if (event.target.contains(this)) this.layout(); }, { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stopMedia();
          this.scheduleRotation();
        }, { signal });
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, { signal });
        this.visibilityObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === this.track) this.inView = entry.isIntersecting;
            else if (!entry.isIntersecting) this.pauseVideo(entry.target);
          });
          this.scheduleRotation();
        });
        this.visibilityObserver.observe(this.track);
        this.videos.forEach(video => this.visibilityObserver.observe(video));
        this.resizeObserver = new ResizeObserver(() => this.layout());
        this.resizeObserver.observe(this.track);
        this.layout();
      }
      layout() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const span = this.slides.reduce((width, slide) => width + slide.offsetWidth, 0) + gap * (this.slides.length - 1);
        const loop = this.slides.length > 1 && span > this.track.clientWidth;
        if (loop !== this.loop) {
          this.querySelectorAll('[data-media-clone]').forEach(slide => slide.remove());
          this.loop = loop;
          this.toggleAttribute('data-static', !loop);
          if (loop) {
            const clone = slide => {
              const copy = slide.cloneNode(true);
              copy.dataset.mediaClone = '';
              copy.removeAttribute('data-block-id');
              copy.removeAttribute('data-shopify-editor-block');
              copy.removeAttribute('id');
              copy.removeAttribute('aria-current');
              copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
              copy.setAttribute('aria-hidden', 'true');
              copy.querySelectorAll('video').forEach(video => {
                const poster = document.createElement(video.poster ? 'img' : 'div');
                poster.className = video.className;
                if (video.poster) { poster.src = video.poster; poster.alt = ''; poster.loading = 'lazy'; }
                video.replaceWith(poster);
              });
              copy.querySelectorAll('[data-play]').forEach(button => {
                const icon = document.createElement('span');
                icon.className = button.className;
                icon.innerHTML = button.innerHTML;
                icon.dataset.play = '';
                button.replaceWith(icon);
              });
              return copy;
            };
            this.track.prepend(...this.slides.map(clone));
            this.track.append(...this.slides.map(clone));
          }
          this.items = [...this.track.querySelectorAll('[data-slide]')];
          this.querySelector('[data-controls]').hidden = !loop;
        }
        this.goTo(this.activeIndex, true);
      }
      select(index) {
        this.current = index;
        const logicalIndex = Number(this.items[index].dataset.mediaIndex);
        if (logicalIndex !== this.activeIndex) {
          this.activeIndex = logicalIndex;
          this.playRequest++;
          this.pendingVideo = null;
          const selectedVideo = this.slides[logicalIndex].querySelector('video');
          this.videos.forEach(video => { if (video !== selectedVideo) this.pauseVideo(video); });
        }
        this.items.forEach(slide => {
          const distance = Math.abs(Number(slide.dataset.mediaIndex) - logicalIndex);
          slide.dataset.distance = Math.min(2, this.loop ? Math.min(distance, this.slides.length - distance) : distance);
          if (!slide.hasAttribute('data-media-clone') && Number(slide.dataset.mediaIndex) === logicalIndex) slide.setAttribute('aria-current', 'true');
          else slide.removeAttribute('aria-current');
        });
        this.status.textContent = this.slides[logicalIndex].dataset.label;
      }
      goTo(index, instant = false) {
        const count = this.slides.length;
        this.scrollToCard((this.loop ? count : 0) + ((index % count) + count) % count, instant);
      }
      step(direction) {
        if (this.loop) this.scrollToCard(Math.max(0, Math.min(this.current + direction, this.items.length - 1)));
      }
      scrollToCard(index, instant = false) {
        const bounds = this.track.getBoundingClientRect();
        const card = this.items[index].getBoundingClientRect();
        if (this.loop) this.track.scrollTo({ left: this.track.scrollLeft + card.left + card.width / 2 - bounds.left - this.track.clientWidth / 2, behavior: instant || this.motion.matches ? 'instant' : 'smooth' });
        this.select(index);
        this.scheduleRotation();
      }
      finishScroll() {
        if (this.loop && (this.current < this.slides.length || this.current >= this.slides.length * 2)) this.goTo(this.activeIndex, true);
        this.scheduleRotation();
      }
      pause() {
        this.paused = true;
        this.scheduleRotation();
      }
      scheduleRotation() {
        clearTimeout(this.timer);
        this.rotation.dataset.paused = String(this.paused);
        this.rotation.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        const playing = this.pendingVideo || this.videos.some(video => !video.paused && !video.ended);
        const rotating = this.isConnected && this.loop && !this.paused && !this.hovered && !this.dragging && this.inView && !document.hidden && !playing;
        this.status.setAttribute('aria-live', rotating ? 'off' : 'polite');
        if (rotating) this.timer = setTimeout(() => this.step(1), 4000);
      }
      canPlay(video) {
        const media = video.getBoundingClientRect();
        const track = this.track.getBoundingClientRect();
        return this.isConnected && !document.hidden && media.width > 0 && media.height > 0 && media.bottom > 0 && media.top < window.innerHeight && Math.min(media.right, track.right, window.innerWidth) > Math.max(media.left, track.left, 0);
      }
      setPlayback(video) {
        const button = video.closest('[data-slide]')?.querySelector('[data-play]');
        if (!button) return;
        button.hidden = !video.paused && !video.ended;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
      pauseVideo(video) {
        if (this.pendingVideo === video) { this.playRequest++; this.pendingVideo = null; }
        video.pause();
        this.setPlayback(video);
      }
      stopMedia() {
        this.playRequest++;
        this.pendingVideo = null;
        this.videos?.forEach(video => this.pauseVideo(video));
      }
      async playVideo(slide) {
        const original = this.slides[Number(slide.dataset.mediaIndex)];
        const video = original.querySelector('video');
        const button = original.querySelector('[data-play]');
        this.goTo(this.slides.indexOf(original), true);
        if (original !== slide) button.focus({ preventScroll: true });
        if (!this.canPlay(video)) return;
        this.videos.forEach(other => { if (other !== video) this.pauseVideo(other); });
        const request = ++this.playRequest;
        this.videoRequests.set(video, request);
        this.pendingVideo = video;
        this.scheduleRotation();
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        try {
          await video.play();
          if (this.videoRequests.get(video) === request && (request !== this.playRequest || !this.canPlay(video) || this.slides[this.activeIndex] !== original)) video.pause();
        } catch {
          if (request === this.playRequest) this.status.textContent = this.dataset.playError;
        } finally {
          if (request === this.playRequest) this.pendingVideo = null;
          if (this.videoRequests.get(video) === request) this.setPlayback(video);
          this.scheduleRotation();
        }
      }
      disconnectedCallback() {
        this.stopMedia();
        this.controller?.abort();
        this.controller = null;
        this.visibilityObserver?.disconnect();
        this.resizeObserver?.disconnect();
        clearTimeout(this.timer);
        clearTimeout(this.settleTimer);
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = 0;
        this.querySelectorAll('[data-media-clone]').forEach(slide => slide.remove());
        delete this.dataset.enhanced;
        this.removeAttribute('data-static');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halo-offer-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halo-offer-bar')) {
    customElements.define('halo-offer-bar', class extends HTMLElement {
      connectedCallback() { if (window.HaloOfferDeadline) this.start(); else document.addEventListener('DOMContentLoaded', () => { if (this.isConnected) this.start(); }, { once: true }); }
      disconnectedCallback() { clearInterval(this.timer); }
      start() {
        clearInterval(this.timer);
        const expiry = window.HaloOfferDeadline?.parse(this.dataset.expiry);
        const timer = this.querySelector('[data-offer-timer]');
        if (!Number.isFinite(expiry)) { if (timer) timer.hidden = true; return; }
        const tick = () => {
          const remaining = expiry - Date.now();
          if (remaining <= 0) { clearInterval(this.timer); this.dataset.expired = ''; if (timer) timer.hidden = true; this.querySelector('[data-offer-expired]')?.removeAttribute('hidden'); return false; }
          const seconds = Math.floor(remaining / 1000);
          const values = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60];
          ['hours', 'minutes', 'seconds'].forEach((name, index) => { const node = this.querySelector(`[data-offer-${name}]`); if (node) node.textContent = String(values[index]).padStart(2, '0'); });
        };
        if (tick() !== false) this.timer = setInterval(tick, 1000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halo-results-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halo-result-stories')) {
    customElements.define('halo-result-stories', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('[data-hrs-track]');
        this.cards = [...this.querySelectorAll('[data-hrs-card]')];
        this.dialogs = [...this.querySelectorAll('.hb-stories__dialog')];
        this.querySelectorAll('[data-hrs-open]').forEach(button => { button.hidden = false; });
        this.addEventListener('click', event => this.handleClick(event), { signal });
        this.dialogs.forEach(dialog => {
          dialog.addEventListener('close', () => this.resetVideo(dialog), { signal });
          dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); }, { signal });
        });
        this.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
          if (card) card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'start' });
        }, { signal });
        if (!this.track) return;
        this.previous = this.querySelector('[data-hrs-previous]');
        this.next = this.querySelector('[data-hrs-next]');
        this.status = this.querySelector('[data-hrs-status]');
        this.navigation = this.querySelector('[data-hrs-navigation]');
        this.track.addEventListener('scroll', () => this.updateNavigation(), { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          const step = { ArrowLeft: rtl ? 1 : -1, ArrowRight: rtl ? -1 : 1 }[event.key];
          if (step) { event.preventDefault(); this.showCard(this.currentIndex + step); }
          if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); this.showCard(event.key === 'Home' ? 0 : this.cards.length - 1); }
        }, { signal });
        this.resizeObserver?.disconnect();
        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        this.resizeObserver.observe(this.track);
        this.updateNavigation();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.dialogs?.forEach(dialog => {
          this.resetVideo(dialog, false);
          if (dialog.open) dialog.close();
        });
      }

      updateNavigation() {
        if (!this.cards.length) return;
        const bounds = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const edge = rtl ? 'right' : 'left';
        const distances = this.cards.map(card => Math.abs(card.getBoundingClientRect()[edge] - bounds[edge]));
        this.currentIndex = distances.indexOf(Math.min(...distances));
        const first = this.cards[0].getBoundingClientRect();
        const last = this.cards[this.cards.length - 1].getBoundingClientRect();
        this.previous.disabled = rtl ? first.right <= bounds.right + 2 : first.left >= bounds.left - 2;
        this.next.disabled = rtl ? last.left >= bounds.left - 2 : last.right <= bounds.right + 2;
        this.navigation.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
        const position = this.cards[this.currentIndex].dataset.hrsPosition;
        if (this.status.textContent !== position) this.status.textContent = position;
      }

      showCard(index) {
        const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
        card?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
      }

      handleClick(event) {
        if (event.target.closest('[data-hrs-previous]')) this.showCard(this.currentIndex - 1);
        if (event.target.closest('[data-hrs-next]')) this.showCard(this.currentIndex + 1);
        const close = event.target.closest('[data-hrs-close]');
        if (close) close.closest('dialog').close();
        const trigger = event.target.closest('[data-hrs-open]');
        if (!trigger) return;
        const dialog = this.dialogs.find(item => item.id === trigger.getAttribute('aria-controls'));
        if (!dialog || dialog.open) return;
        this.activeTrigger = trigger;
        this.activeDialog = dialog;
        dialog.showModal();
      }

      resetVideo(dialog, restoreFocus = true) {
        dialog.querySelectorAll('video').forEach(video => {
          video.pause();
          try { video.currentTime = 0; } catch (_) {}
        });
        if (dialog === this.activeDialog) {
          if (restoreFocus && this.activeTrigger?.isConnected) this.activeTrigger.focus({ preventScroll: true });
          this.activeDialog = null;
          this.activeTrigger = null;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halo-signup-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halo-signup-popup')) {
    customElements.define('halo-signup-popup', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort(); this.controller = new AbortController();
        const signal = this.controller.signal;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        if (!this.querySelector('form') && this.dataset.designMode !== 'true') return;
        this.addEventListener('click', event => { if (event.target.closest('[data-hsp-close]')) this.dialog.close(); }, { signal });
        this.addEventListener('halo:signup-success', () => this.showSuccess(), { signal });
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, { signal });
        this.dialog.addEventListener('close', () => this.restoreFocus(), { signal });
        document.addEventListener('shopify:section:select', event => { if (event.detail?.sectionId === this.dataset.sectionId) this.preview(); }, { signal });
        document.addEventListener('shopify:section:deselect', event => { if (event.detail?.sectionId === this.dataset.sectionId && this.dialog.open) this.dialog.close(); }, { signal });
        this.bindManual();
        if (location.hash === `#${this.dataset.returnAnchor}`) this.open(null, true);
        else if (this.dataset.designMode !== 'true') this.bindAutomatic();
      }
      disconnectedCallback() { this.controller?.abort(); clearTimeout(this.delayTimer); clearTimeout(this.mobileTimer); if (this.dialog?.open) this.dialog.close(); }
      bindManual() {
        const selector = `a[href="#${CSS.escape(this.dataset.anchor)}"]`;
        document.addEventListener('click', event => { const link = event.target.closest(selector); if (!link || event.defaultPrevented) return; event.preventDefault(); this.open(link, true); }, { signal: this.controller.signal });
      }
      bindAutomatic() {
        if (this.wasSeen()) return;
        const trigger = this.dataset.trigger;
        if (trigger === 'after_delay' || trigger === 'delay_or_exit') this.delayTimer = setTimeout(() => this.open(), Number(this.dataset.delay));
        if (trigger === 'exit_intent' || trigger === 'delay_or_exit') {
          if (matchMedia('(hover: hover) and (pointer: fine)').matches) document.addEventListener('mouseout', event => { if (!event.relatedTarget && event.clientY <= 0) this.open(); }, { signal: this.controller.signal });
          else if (Number(this.dataset.mobileExitDelay) > 0) this.mobileTimer = setTimeout(() => this.open(), Number(this.dataset.mobileExitDelay));
        }
        if (trigger === 'scroll_depth') window.addEventListener('scroll', () => { const height = document.documentElement.scrollHeight - innerHeight; if (height && scrollY / height * 100 >= Number(this.dataset.scrollDepth)) this.open(); }, { passive: true, signal: this.controller.signal });
      }
      open(trigger, manual) {
        if (this.dialog.open || (!manual && (this.pageShown || this.wasSeen()))) return;
        clearTimeout(this.delayTimer); clearTimeout(this.mobileTimer);
        const active = this.constructor.activeDialog;
        if (!manual && active?.open && active !== this.dialog) return;
        if (active && active !== this.dialog) active.close();
        this.activeTrigger = trigger || document.activeElement;
        this.constructor.activeDialog = this.dialog;
        this.dialog.showModal();
        this.pageShown = true;
        if (this.dataset.designMode !== 'true') this.markSeen();
      }
      preview() { if (!this.dialog.open) this.open(null, true); }
      showSuccess() { const form = this.querySelector('[data-hsp-form-wrap]'); const success = this.querySelector('[data-hsp-success]'); if (form && success) { form.hidden = true; success.hidden = false; success.querySelector('button')?.focus(); } }
      storage() { try { return this.dataset.revisit === 'session' ? sessionStorage : localStorage; } catch (_) { return null; } }
      key() { return `halo-signup:${this.dataset.campaignKey}`; }
      wasSeen() { if (this.dataset.revisit === 'always') return false; try { const value = this.storage()?.getItem(this.key()); if (!value) return false; return this.dataset.revisit === 'session' || Number(value) > Date.now(); } catch (_) { return false; } }
      markSeen() { if (this.dataset.revisit === 'always') return; const store = this.storage(); if (!store) return; try { store.setItem(this.key(), this.dataset.revisit === 'session' ? '1' : String(Date.now() + Number(this.dataset.days) * 86400000)); } catch (_) {} }
      restoreFocus() { if (this.constructor.activeDialog === this.dialog) this.constructor.activeDialog = null; if (this.activeTrigger?.focus && this.activeTrigger.isConnected) this.activeTrigger.focus({ preventScroll: true }); this.activeTrigger = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halo-sticky-cart"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('halo-sticky-purchase')) {
  customElements.define('halo-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const panel = this.querySelector('halo-purchase');
      const update = () => {
        const allowed = this.hasAttribute('data-editor') || (document.querySelector('halo-sticky-purchase') === this && !document.querySelector('[data-halo-sticky]'));
        panel.hidden = !allowed || (!this.hasAttribute('data-editor') && window.scrollY < Number(this.dataset.showAfter));
      };
      window.addEventListener('scroll', update, { passive: true, signal: this.controller.signal });
      document.addEventListener('shopify:section:unload', () => queueMicrotask(update), { signal: this.controller.signal });
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halo-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halo-testimonials')) {
    customElements.define('halo-testimonials', class extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.track = this.querySelector('[data-testimonial-track]');
        this.cards = Array.from(this.querySelectorAll('[data-testimonial-card]'));
        if (!this.track || !this.cards.length) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.rotation = this.querySelector('[data-testimonial-rotation]');
        this.status = this.querySelector('[data-testimonial-current]');
        this.announcement = this.querySelector('[data-testimonial-announcement]');
        this.controls = this.querySelector('[data-testimonial-controls]');
        this.active = Math.min(this.active ?? Math.floor((this.cards.length - 1) / 2), this.cards.length - 1);
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || this.dataset.designMode === 'true';
        this.hovered = false;
        this.dragging = false;
        this.inView = false;
        this.loop = null;
        this.cards.forEach((card, index) => { card.dataset.testimonialIndex = index; });
        this.addEventListener('click', event => {
          if (event.target.closest('[data-testimonial-rotation]')) {
            this.paused = !this.paused;
            this.scheduleRotation();
          }
          const button = event.target.closest('[data-testimonial-step]');
          if (button) { this.pause(); this.step(Number(button.dataset.testimonialStep)); }
        }, options);
        this.addEventListener('focusin', event => {
          if (event.target !== this.rotation) this.pause();
        }, options);
        this.track.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.scheduleRotation(); }
        }, options);
        this.track.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.scheduleRotation();
        }, options);
        this.track.addEventListener('pointerdown', () => {
          this.dragging = true;
          this.scheduleRotation();
        }, options);
        for (const type of ['pointerup', 'pointercancel']) document.addEventListener(type, () => {
          if (!this.dragging) return;
          this.dragging = false;
          this.scheduleRotation();
        }, options);
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.pause();
          if (event.key === 'Home' || event.key === 'End') this.goTo(event.key === 'Home' ? 0 : this.cards.length - 1);
          else this.step(event.key === 'ArrowRight' ? direction : -direction);
        }, options);
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.timer);
          clearTimeout(this.settleTimer);
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            const bounds = this.track.getBoundingClientRect();
            const center = bounds.left + bounds.width / 2;
            let nearest = 0;
            let distance = Infinity;
            this.items.forEach((card, index) => {
              const rect = card.getBoundingClientRect();
              const delta = Math.abs(rect.left + rect.width / 2 - center);
              if (delta < distance) { nearest = index; distance = delta; }
            });
            this.update(nearest);
          });
          this.settleTimer = setTimeout(() => this.finishScroll(), 120);
        }, { ...options, passive: true });
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.blockId === event.detail?.blockId || card.contains(event.target));
          if (index >= 0) { this.pause(); this.goTo(index, false); }
        }, options);
        document.addEventListener('shopify:section:reorder', event => {
          if (event.target.contains(this)) this.layout();
        }, options);
        document.addEventListener('visibilitychange', () => this.scheduleRotation(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, options);
        this.visibility = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.scheduleRotation();
        });
        this.visibility.observe(this.track);
        this.resize = new ResizeObserver(() => this.layout());
        this.resize.observe(this.track);
        this.layout();
        this.setAttribute('data-ready', '');
      }
      layout() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const span = this.cards.reduce((width, card) => width + card.offsetWidth, 0) + gap * (this.cards.length - 1);
        const loop = this.cards.length > 1 && span > this.track.clientWidth - 40;
        if (loop !== this.loop) {
          this.querySelectorAll('[data-testimonial-clone]').forEach(card => card.remove());
          this.loop = loop;
          this.toggleAttribute('data-static', !loop);
          if (loop) {
            const clone = card => {
              const copy = card.cloneNode(true);
              copy.dataset.testimonialClone = '';
              copy.removeAttribute('data-block-id');
              copy.removeAttribute('data-shopify-editor-block');
              copy.removeAttribute('id');
              copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
              copy.setAttribute('aria-hidden', 'true');
              copy.inert = true;
              return copy;
            };
            this.track.prepend(...this.cards.map(clone));
            this.track.append(...this.cards.map(clone));
          }
          this.items = Array.from(this.track.querySelectorAll('[data-testimonial-card]'));
          if (this.controls) this.controls.hidden = !loop;
        }
        this.goTo(this.active, false);
      }
      update(index) {
        this.current = index;
        this.active = Number(this.items[index].dataset.testimonialIndex);
        this.items.forEach(card => card.toggleAttribute('data-current', Number(card.dataset.testimonialIndex) === this.active));
        if (this.status) this.status.textContent = String(this.active + 1);
      }
      goTo(index, smooth = true) {
        const count = this.cards.length;
        this.scrollToCard((this.loop ? count : 0) + ((index % count) + count) % count, smooth);
      }
      step(direction) {
        if (!this.loop) return;
        this.scrollToCard(Math.max(0, Math.min(this.current + direction, this.items.length - 1)));
      }
      scrollToCard(index, smooth = true) {
        const card = this.items[index].getBoundingClientRect();
        const track = this.track.getBoundingClientRect();
        if (this.loop) this.track.scrollTo({ left: this.track.scrollLeft + card.left + card.width / 2 - track.left - track.width / 2, behavior: smooth && !this.motion.matches ? 'smooth' : 'instant' });
        this.update(index);
        this.scheduleRotation();
      }
      finishScroll() {
        if (this.loop && (this.current < this.cards.length || this.current >= this.cards.length * 2)) this.goTo(this.active, false);
        this.scheduleRotation();
      }
      pause() {
        this.paused = true;
        this.scheduleRotation();
      }
      scheduleRotation() {
        clearTimeout(this.timer);
        if (this.rotation) {
          this.rotation.dataset.paused = String(this.paused);
          this.rotation.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        }
        const rotating = this.isConnected && this.loop && !this.paused && !this.hovered && !this.dragging && this.inView && !document.hidden;
        this.announcement?.setAttribute('aria-live', rotating ? 'off' : 'polite');
        if (rotating) this.timer = setTimeout(() => this.step(1), 4000);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.visibility?.disconnect();
        clearTimeout(this.timer);
        clearTimeout(this.settleTimer);
        cancelAnimationFrame(this.frame);
        this.querySelectorAll('[data-testimonial-clone]').forEach(card => card.remove());
        this.removeAttribute('data-ready');
        this.removeAttribute('data-static');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
